import React, { useState, useEffect, useRef } from 'react'
import {
  I2cButton,
  I2cIcon,
  I2cTooltip,
  I2cRadioGroup,
  I2cRadioButton,
  I2cFileUpload,
  I2cTextarea,
  I2cInput,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cRadio, I2cSelect, I2cMenuItem
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import {
  navigation, logo_Options, link_Options, self_Service_Options, card_Activation_Options,
  video_Link_Options, add_image_of_mobile_Options, which_Products, card_product_images,
  content_blocks_images, add_Links_For, specify_Info, add_section_Landing_Options, publicPageSelection
} from "./stringUtils";
import FilesUploadService from "../../../Services/FilesUploadService";
import { useMutation } from "react-query";
import { validationSchemaWeb } from "./ValidationSchema";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"

const WebAppPublicPageSpecifications = ({
  type,
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const [nav, setNav] = useState(0);
  const [fileJson, setFileJson] = useState([]);
  const checkboxRef = useRef(null);
  const sectionsRef = useRef([]);
  const appSelectionForProgram = addFormData[1]?.["1_0"]?.app_selection_for_program || [];
  const inner_index_str = type === "credit" ? "2_2" : "3_2";
  // const fileJson = type === "credit" ? formDataJson[2]["2_2"] : formDataJson[3]["3_2"];
  const handleNav = (active) => {
    setNav(active);
    sectionsRef.current[active].scrollIntoView({ behavior: 'smooth' });
  }
  const Manual = useRef(null);
  const fileRefs = useRef({});
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchemaWeb),
    mode: "all",
    reValidateMode: "all",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      brand_info_web_app_add_program_logo: "Yes",
      brand_info_web_app_program_logo_file: "",
      brand_info_web_app_add_link_to_public_pages: "Yes",
      brand_info_web_app_add_link_to_self_service_enrollment: "Yes",
      brand_info_web_app_add_card_activation_feature: "Yes",
      brand_info_web_app_main_banner_file: "",
      brand_info_web_app_heading_and_text: "",
      brand_info_web_app_add_video_link: "Yes",
      brand_info_web_app_video_url: "",
      brand_info_web_app_offer_card_products_for_enrollment: [],
      brand_info_web_app_content_for_card_products: "",
      brand_info_web_app_responsible_for_card_product_images: "i2c to provide images",
      brand_info_web_app_card_product_images_file: [],
      brand_info_web_app_content_for_card_products_features: "",
      brand_info_web_app_responsible_for_card_products_features_images: "i2c to provide images",
      brand_info_web_app_card_products_features_images_file: [],
      brand_info_web_info_section_vi_add_section_to_landing_page: "Yes",
      brand_info_web_info_section_vi_icon_textual_content_images_file: [],
      brand_info_web_info_add_image_of_mobile_app_section: "Yes",
      brand_info_web_info_add_links_for_app: [],
      brand_info_web_info_mobile_app_images_file: [],
      brand_info_web_info_footer_public_pages_links: [],
      brand_info_web_info_footer_public_pages_content: "",
      brand_info_web_app_public_pages: [
        { page_name: "FAQs", page_link: "https://your-url-1.com", isDefault: true },
        { page_name: "Contact Us", page_link: "https://your-url-2.com", isDefault: true },
        { page_name: "Home", page_link: "https://your-url-3.com", isDefault: true },
        { page_name: "Service", page_link: "https://your-url-4.com", isDefault: true },
      ],
    },
  });
  const fields = [
    "brand_info_web_app_add_program_logo",
    "brand_info_web_app_program_logo_file",
    "brand_info_web_app_add_link_to_public_pages",
    "brand_info_web_app_add_link_to_self_service_enrollment",
    "brand_info_web_app_add_card_activation_feature",
    "brand_info_web_app_main_banner_file",
    "brand_info_web_app_heading_and_text",
    "brand_info_web_app_add_video_link",
    "brand_info_web_app_video_url",
    "brand_info_web_app_content_for_card_products",
    "brand_info_web_app_responsible_for_card_product_images",
    "brand_info_web_app_content_for_card_products_features",
    "brand_info_web_app_responsible_for_card_products_features_images",
    "brand_info_web_info_section_vi_add_section_to_landing_page",
    "brand_info_web_info_add_image_of_mobile_app_section",
    "brand_info_web_info_footer_public_pages_content",
  ];

  const fieldsArray = [
    "brand_info_web_app_offer_card_products_for_enrollment",
    "brand_info_web_info_add_links_for_app",
    "brand_info_web_info_footer_public_pages_links",
    "brand_info_web_app_card_product_images_file",
    "brand_info_web_app_card_products_features_images_file",
    "brand_info_web_info_section_vi_icon_textual_content_images_file",
    "brand_info_web_info_mobile_app_images_file",
    "brand_info_web_app_public_pages",
  ];

  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      if (type === "credit") {
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[2]["2_2"][field] ?? "");
        });
        fieldsArray.forEach((field) => {
          methods.setValue(field, formDataJson[2]["2_2"][field] ?? []);
        });
        setFileJson(formDataJson[2]["2_2"]);
      }
      else {
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[3]["3_2"][field] ?? "");
        });
        fieldsArray.forEach((field) => {
          methods.setValue(field, formDataJson[3]["3_2"][field] ?? []);
        });
        setFileJson(formDataJson[3]["3_2"]);
      }
      methods.trigger();
      handleValueChanges();
    }
  }, [isFetching]);

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;
  const { fields: fieldss, append, remove } = useFieldArray({
    control,
    name: "brand_info_web_app_public_pages", // Name of the array field in your form,
  });
  // useEffect(() => {
  //   const selected = methods.getValues("brand_info_web_app_add_link_to_public_pages");
  //   const currentPages = methods.getValues("brand_info_web_app_public_pages");
  
  //   const isEmptyOrDefault =
  //     !currentPages ||
  //     currentPages.length === 0 ||
  //     (currentPages.length === 1 &&
  //       !currentPages[0].page_name &&
  //       !currentPages[0].page_link &&
  //       !currentPages[0].isDefault);
  
  //   if (selected === "Yes" && isEmptyOrDefault) {
  //     methods.setValue("brand_info_web_app_public_pages", [
  //       { page_name: "FAQs", page_link: " ", isDefault: true },
  //       { page_name: "Contact Us", page_link: " ", isDefault: true },
  //       { page_name: "Home", page_link: " ", isDefault: true },
  //       { page_name: "Service", page_link: " ", isDefault: true },
  //     ]);
  //     methods.trigger();
  //   }
  // }, []);
  
  useEffect(() => {
    const selected = methods.getValues("brand_info_web_app_add_link_to_public_pages");
    const currentPages = methods.getValues("brand_info_web_app_public_pages");

    if (
        selected === "Yes" &&
        (!currentPages || currentPages.length === 0)
    ) {
        methods.setValue("brand_info_web_app_public_pages", [
            { page_name: "FAQs", page_link: " ", isDefault: true },
            { page_name: "Contact Us", page_link: " ", isDefault: true },
            { page_name: "Home", page_link: " ", isDefault: true },
            { page_name: "Service", page_link: " ", isDefault: true },
        ]);
        methods.trigger();
        handleValueChanges();
    }
}, []);
  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const formData = new FormData();


  // Dynamically create and access refs based on field names
  const getFileRef = (fieldName) => {
    if (!fileRefs.current[fieldName]) {
      fileRefs.current[fieldName] = React.createRef();
    }
    return fileRefs.current[fieldName];
  };

  useEffect(() => {
    customElements.whenDefined('i2c-file-upload').then(() => {
      Object.keys(fileRefs.current).forEach((fieldName) => {
        const fileRef = fileRefs.current[fieldName];
        if (fileRef.current !== null) {
          const myDropzone = fileRef.current.getDropZone();
          const token = localStorage.getItem("token");
          myDropzone.options.url = process.env.REACT_APP_API_BASE_URL + "api/file/upload/pdf";
          myDropzone.options.headers = {
            'X-Requested-With': null,
            'Access-Control-Allow-Headers': null,
            'Authorization': 'Bearer ' + token,
          };
        }
      });
    });
  }, []);
  // for PDF, svg, ai files
  const handleFileUpload = async (file, fieldName) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      await fileUpload.mutate({ formData, fieldName });
    } catch (error) {
      console.log(error);
    } finally {
      methods.trigger();
    }
  };

  const fileUpload = useMutation({
    mutationFn: async ({ formData, fieldName }) => {
      setFormValidStates(inner_index_str, false);
      return await FilesUploadService.uploadFile(formData);
    },
    onSuccess: (data, { fieldName }) => {
      if (fieldName === "brand_info_web_info_section_vi_icon_textual_content_images_file") {
        const currentFiles = methods.getValues(fieldName) || [];
        methods.setValue(fieldName, [...currentFiles, data?.data?.url]);
      }
      else {
        methods.setValue(fieldName, data?.data?.url);
      }

      methods.trigger();
      handleValueChanges();
    },
    onError: (e) => {
      console.log("API error", e);
    },
  });
  // for only images jpg/png
  const handleFileUploadImage = async (file, fieldName) => {
    const formDataImages = new FormData();
    formDataImages.append("file", file);
    try {
      await fileUploadImage.mutate({ formDataImages, fieldName });
    } catch (error) {
      console.log(error);
    } finally {
      methods.trigger();
    }
  };

  const fileUploadImage = useMutation({
    mutationFn: async ({ formDataImages, fieldName }) => {
      setFormValidStates(inner_index_str, false);
      return await FilesUploadService.uploadFileImage(formDataImages);
    },
    onSuccess: (data, { fieldName }) => {
      if (fieldName === "brand_info_web_app_card_product_images_file" || fieldName === "brand_info_web_app_card_products_features_images_file"
        || fieldName === "brand_info_web_info_mobile_app_images_file"
      ) {
        const currentFiles = methods.getValues(fieldName) || [];
        methods.setValue(fieldName, [...currentFiles, data?.data?.url]);
      }
      else {
        methods.setValue(fieldName, data?.data?.url);
      }
      methods.trigger();
      handleValueChanges();
    },
    onError: (e) => {
      console.log("api error");
    },
  });

  const handleValueChanges = () => {
    const values = methods.getValues();
    if (type === "credit") {
      setAddFormData({
        ...addFormData,
        2: {
          ...addFormData["2"],
          "2_2": { ...values },
        },
      });
    }
    else {
      setAddFormData({
        ...addFormData,
        3: {
          ...addFormData["3"],
          "3_2": { ...values },
        },
      });
    }
  };

  const handleWhichProducts = (event) => {
    let selectedCardInfo;
    selectedCardInfo = event;
    let updatedSelectedCardsInfo = [
      ...methods.getValues("brand_info_web_app_offer_card_products_for_enrollment"),
    ];

    if (updatedSelectedCardsInfo.includes(selectedCardInfo)) {
      // If the card is already selected, remove it
      updatedSelectedCardsInfo = updatedSelectedCardsInfo.filter(
        (card) => card !== selectedCardInfo,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedCardsInfo.push(selectedCardInfo);
    }
    // if (!updatedSelectedCardsInfo.includes(4)) {
    //   methods.setValue("brand_info_web_app_offer_card_products_for_enrollment_other", "");
    // }
    methods.setValue("brand_info_web_app_offer_card_products_for_enrollment", updatedSelectedCardsInfo);
    methods.trigger();
    handleValueChanges();
  };

  const handleAddLinks = (event) => {
    let selectedCardInfo;
    selectedCardInfo = event;
    let updatedSelectedCardsInfo = [
      ...methods.getValues("brand_info_web_info_add_links_for_app"),
    ];

    if (updatedSelectedCardsInfo.includes(selectedCardInfo)) {
      // If the card is already selected, remove it
      updatedSelectedCardsInfo = updatedSelectedCardsInfo.filter(
        (card) => card !== selectedCardInfo,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedCardsInfo.push(selectedCardInfo);
    }
    // if (!updatedSelectedCardsInfo.includes(4)) {
    //   methods.setValue("brand_info_web_info_add_links_for_app_other", "");
    // }
    methods.setValue("brand_info_web_info_add_links_for_app", updatedSelectedCardsInfo);
    methods.trigger();
    handleValueChanges();
  }

  const handleSpecifyInfo = (event) => {
    let selectedCardInfo;
    selectedCardInfo = event;
    let updatedSelectedCardsInfo = [
      ...methods.getValues("brand_info_web_info_footer_public_pages_links"),
    ];

    if (updatedSelectedCardsInfo.includes(selectedCardInfo)) {
      // If the card is already selected, remove it
      updatedSelectedCardsInfo = updatedSelectedCardsInfo.filter(
        (card) => card !== selectedCardInfo,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedCardsInfo.push(selectedCardInfo);
    }
    // if (!updatedSelectedCardsInfo.includes(4)) {
    //   methods.setValue("brand_info_web_info_footer_public_pages_links_other", "");
    // }
    methods.setValue("brand_info_web_info_footer_public_pages_links", updatedSelectedCardsInfo);
    methods.trigger();
    handleValueChanges();
  }
  console.log("error in web", errors);
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors)?.length;
    if (type === "credit") {
      if (errorsLength === 0) setFormValidStates("2_2", true);
      else setFormValidStates("2_2", false);
    }
    else {
      if (errorsLength === 0) setFormValidStates("3_2", true);
      else setFormValidStates("3_2", false);
    }
  }, [Object.keys(errors)?.length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div className="custom-label-light">
          This section must be filled if you have indicated above that you want to offer i2c C-Holder Web to your cardholders.
        </div>
        <div className="sticky-position-nav">
          <div className='web-app-public-nav-wrapper'>
            {navigation.map((nv, idx) => <I2cButton onClick={() => handleNav(idx)} key={idx} variant={`${nav === idx ? "secondary color" : "tertiary gray"}`} size='small'>{nv}</I2cButton>)}
          </div>
        </div>
        <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[0] = el}>
          <div i2c-grid="12 8@md">
            <div className="sub-heading">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  Header
                  <I2cTooltip
                    content="The content of all public pages, including the ones that have their links in the Header section, will be required in the “Branding Specifications Common to Both Mobile and Web Apps” section below. "
                    placement="right-start"
                  >
                    <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
                  </I2cTooltip>
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
            <div className="custom-label">
              Header can include the brand or program logo, the new card enrollment / user creation link, links to public pages, and language options.
            </div>
          </div>
          <div i2c-grid="12 12@md">
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_app_add_program_logo"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Add company or program logo?"
                    {...field}
                    name="brand_info_web_app_add_program_logo"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {logo_Options.map((lo, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("brand_info_web_app_add_program_logo") === lo
                        }
                        value={lo}
                      >
                        {lo}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.brand_info_web_app_add_program_logo &&
                    methods.formState.touchedFields.brand_info_web_app_add_program_logo
                    ? true
                    : false
                }
                message={errors.brand_info_web_app_add_program_logo?.message ?? "Invalid input"}
              />
            </div>
          </div>

          {methods.watch("brand_info_web_app_add_program_logo") === "Yes" && (
            <div i2c-grid="12 12@md">
              <div className="custom-label mb-8">
                Upload logo source file
              </div>
              <Controller
                name="brand_info_web_app_program_logo_file"
                control={control}
                render={({ field }) => (
                  <I2cFileUpload
                    ref={getFileRef("brand_info_web_app_program_logo_file")}
                    autoProcessQueue={false}
                    no-mobile-controls
                    max-files={1}
                    className="customFileUpload"
                    setAcceptedFiles=".svg, .ai, .pdf, .eps"
                    icon="linear-document-upload"
                    label="Click to upload"
                    caption="or drag and drop"
                    name="brand_info_web_app_program_logo_file"
                    message="Format must be SVG, AI, PDF or EPS Format."
                    onI2cFileRemoved={(e) => {
                      if (
                        fileJson?.brand_info_web_app_program_logo_file?.length
                      )
                        methods.setValue(
                          "brand_info_web_app_program_logo_file",
                          fileJson?.brand_info_web_app_program_logo_file,
                        );
                      else methods.setValue("brand_info_web_app_program_logo_file", "");
                      methods.trigger();
                      handleValueChanges();
                    }}
                    onI2cAddedFile={(e) => {
                      const fileRef = getFileRef("brand_info_web_app_program_logo_file");
                      handleFileUpload(
                        fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                        "brand_info_web_app_program_logo_file"
                      );
                    }}
                  />
                )}
              />
            </div>
          )}

          <div i2c-grid="12 12@md">
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_app_add_link_to_public_pages"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Add links to public pages?"
                    {...field}
                    name="brand_info_web_app_add_link_to_public_pages"
                    onI2cChange={(e) => {
                      if (e.target.value === "Yes") {
                        methods.setValue("brand_info_web_app_public_pages", [
                          { page_name: "FAQs", page_link: " ", isDefault: true },
                          { page_name: "Contact Us", page_link: " ", isDefault: true },
                          { page_name: "Home", page_link: " ", isDefault: true },
                          { page_name: "Service", page_link: " ", isDefault: true },
                        ]);
                      } else {
                        methods.setValue("brand_info_web_app_public_pages", []);
                      }
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {link_Options.map((lo, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("brand_info_web_app_add_link_to_public_pages") === lo
                        }
                        value={lo}
                      >
                        {lo}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.brand_info_web_app_add_link_to_public_pages &&
                    methods.formState.touchedFields.brand_info_web_app_add_link_to_public_pages
                    ? true
                    : false
                }
                message={errors.brand_info_web_app_add_link_to_public_pages?.message ?? "Invalid input"}
              />
            </div>
          </div>
          {methods.watch("brand_info_web_app_add_link_to_public_pages") === "Yes" && (
            <>
              <div i2c-grid="12@md">
                {fieldss.map((row, index) => (
                  <React.Fragment key={index}>
                    <div key={row.id} className="fields-flex mb-16">
                      <Controller
                        name={`page_name`}
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            key={field.name + index}
                            className="single-input-field"
                            placeholder=""
                            required
                            value={methods.watch(`brand_info_web_app_public_pages.${index}.page_name`) || ""}
                            disabled={row.isDefault}
                            onI2cInput={(e) => {
                              if (!row.isDefault) { // Only allow modification for non-default items
                                methods.setValue(
                                  `brand_info_web_app_public_pages.${index}.page_name`,
                                  e.target.value,
                                );
                                methods.trigger();
                              }
                            }}
                            // onI2cInput={(e) => {
                            //   const value = e.target.value;
                            //   field.onChange(value);
                            //   handleValueChanges();
                            //   methods.trigger();
                            // }}
                            onI2cChange={() => handleValueChanges()}
                            size="large"
                            label=""
                            name={`page_name`}
                          />
                        )}
                      />

                      {/* Page link field (always editable) */}
                      <Controller
                        name={`page_link`}
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            key={field.name + index}
                            className="single-input-field"
                            placeholder="www.i2cinc.com"
                            required
                            value={methods.watch(`brand_info_web_app_public_pages.${index}.page_link`) || ""}
                            onI2cInput={(e) => {
                              methods.setValue(
                                `brand_info_web_app_public_pages.${index}.page_link`,
                                e.target.value,
                              );
                              methods.trigger();
                            }}
                            onI2cChange={() => handleValueChanges()}
                            size="large"
                            label=""
                            name={`page_link`}
                            type="url"
                            prefix_label="http://"
                          />
                        )}
                      />
                      <I2cButton
                        size="large"
                        variant="gray dark"
                        onClick={() => {
                          remove(index);
                          methods.trigger();
                          handleValueChanges();
                      }}
                      >
                        <I2cIcon name="linear-trash" label="delete"></I2cIcon>
                      </I2cButton>
                    </div>
                  </React.Fragment>
                ))}

                <div className="mt-16">
                  <I2cButton
                    size="small"
                    variant="primary"
                    className=""
                    onClick={() => {
                      append({
                        page_name: "",
                        page_link: "",
                        isDefault: false,
                      });
                    }}
                  >
                    Add More
                  </I2cButton>
                </div>
              </div>
            </>
          )}
          <div i2c-grid="12 12@md">
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_app_add_link_to_self_service_enrollment"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Add link to the self-service enrollment feature?"
                    {...field}
                    name="brand_info_web_app_add_link_to_self_service_enrollment"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {self_Service_Options.map((sso, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("brand_info_web_app_add_link_to_self_service_enrollment") === sso
                        }
                        value={sso}
                      >
                        {sso}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.brand_info_web_app_add_link_to_self_service_enrollment &&
                    methods.formState.touchedFields.brand_info_web_app_add_link_to_self_service_enrollment
                    ? true
                    : false
                }
                message={errors.brand_info_web_app_add_link_to_self_service_enrollment?.message ?? "Invalid input"}
              />
            </div>
          </div>
        </div>
        <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[1] = el}>
          <div i2c-grid="12 6@md" >
            <div className="sub-heading">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  Card Activation
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
            <div className="custom-label">
              Cardholders can access the card activation feature on the landing page.
            </div>
          </div>
          <div i2c-grid="12 12@md">
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_app_add_card_activation_feature"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Do you want to add this option to the landing page?"
                    {...field}
                    name="brand_info_web_app_add_card_activation_feature"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {card_Activation_Options.map((cAO, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("brand_info_web_app_add_card_activation_feature") === cAO
                        }
                        value={cAO}
                      >
                        {cAO}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.brand_info_web_app_add_card_activation_feature &&
                    methods.formState.touchedFields.brand_info_web_app_add_card_activation_feature
                    ? true
                    : false
                }
                message={errors.brand_info_web_app_add_card_activation_feature?.message ?? "Invalid input"}
              />
            </div>
          </div>
        </div>
        <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[2] = el}>
          <div i2c-grid="12 6@md">
            <div className="sub-heading">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  Main Banner
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
          </div>
          <div i2c-grid="12 12@md">
            <>
              <div className="custom-label-light mb-1-5">
                Upload main banner source file
              </div>
              <Controller
                name="brand_info_web_app_main_banner_file"
                control={control}
                render={({ field }) => (
                  <I2cFileUpload
                    ref={getFileRef("brand_info_web_app_main_banner_file")}
                    autoProcessQueue={false}
                    no-mobile-controls
                    max-files={1}
                    className="customFileUpload"
                    setAcceptedFiles=".png, .svg, .jpg, .ai"
                    icon="linear-document-upload"
                    label="Click to upload"
                    caption="or drag and drop"
                    name="brand_info_web_app_main_banner_file"
                    message="Minimum resolution 2560 x 1440 pixels. SVG, AI, JPG or PNG Format."
                    onI2cFileRemoved={(e) => {
                      if (
                        fileJson?.brand_info_web_app_main_banner_file?.length
                      )
                        methods.setValue(
                          "brand_info_web_app_main_banner_file",
                          fileJson?.brand_info_web_app_main_banner_file,
                        );
                      else methods.setValue("brand_info_web_app_main_banner_file", "");
                      methods.trigger();
                      handleValueChanges();
                    }}
                    onI2cAddedFile={(e) => {
                      const fileRef = getFileRef("brand_info_web_app_main_banner_file");
                      handleFileUpload(
                        fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                        "brand_info_web_app_main_banner_file"
                      );
                    }}
                  />
                )}
              />
            </>
          </div>
          <div i2c-grid="12 12@md">
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_app_heading_and_text"
                control={control}
                render={({ field }) => (
                  <I2cTextarea
                    label="Provide textual content (heading and details) required for this section. "
                    {...field}
                    name="brand_info_web_app_heading_and_text"
                    resize="none"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      methods.trigger();
                      handleValueChanges();
                    }}
                    placeholder="Enter details"
                    rows={5}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.brand_info_web_app_heading_and_text &&
                    methods.formState.touchedFields.brand_info_web_app_heading_and_text
                    ? true
                    : false
                }
                message={errors.brand_info_web_app_heading_and_text?.message ?? "Invalid input"}
              />
            </div>
          </div>
          <div i2c-grid="12 12@md">
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_app_add_video_link"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Do you want to add a video link to the landing page?"
                    {...field}
                    name="brand_info_web_app_add_video_link"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      if(e.target.value !== "Yes"){
                        methods.setValue("brand_info_web_app_video_url","")
                      }
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {video_Link_Options.map((vlo, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("brand_info_web_app_add_video_link") === vlo
                        }
                        value={vlo}
                      >
                        {vlo}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.brand_info_web_app_add_video_link &&
                    methods.formState.touchedFields.brand_info_web_app_add_video_link
                    ? true
                    : false
                }
                message={errors.brand_info_web_app_add_video_link?.message ?? "Invalid input"}
              />
            </div>
          </div>
          {methods.watch("brand_info_web_app_add_video_link") === "Yes" && (
            <div i2c-grid="12 7@md">
              <div className="single-field-wrapper">
                <Controller
                  name="brand_info_web_app_video_url"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="www.i2cinc.com"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"brand_info_web_app_video_url"}
                      prefix_label="http://"
                    >
                      <span slot="label" className="organize-tooltip">
                        <span className="custom-label">
                          {" "}
                          Please specify the URL for video.
                          <sup>•</sup>
                        </span>
                      </span>
                      <I2cIcon slot="suffix" name="cs-linear-help-circle"></I2cIcon>
                    </I2cInput>
                  )}
                />
              </div>
            </div>
          )}

        </div>
        <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[3] = el}>
          <div i2c-grid="12 12@md">
            <div className="sub-heading">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  Feature Section IV
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
            <div className="custom-label">
              This section shows the card products that you want to offer for enrollment.
            </div>
          </div>
          <div i2c-grid="12">
            <div className="custom-label mb-1-5">
              Which products do you want to show?
            </div>
            <Controller
              name="brand_info_web_app_offer_card_products_for_enrollment"
              control={control}
              render={({ field }) => (
                <I2cCheckboxGroup name="brand_info_web_app_offer_card_products_for_enrollment" ref={checkboxRef}>
                  <div i2c-grid="grid gap-sm">
                    {which_Products.map((card, index) => (
                      <div key={index} i2c-grid="4@md">
                        <I2cListItem
                          variant="receipt"
                          label={card.label}
                          sublabel=""
                          value=""
                          type="checkbox"
                          checked={methods
                            .watch("brand_info_web_app_offer_card_products_for_enrollment")
                            .includes(card.value)}
                          onI2cCheckboxClicked={(e) =>
                            handleWhichProducts(card.value)
                          }
                        >
                          <I2cCheckbox
                            slot="prefix"
                            value={card.value}
                            label=""
                            ignoreTab
                            filled
                            checked={methods
                              .watch("brand_info_web_app_offer_card_products_for_enrollment")
                              .includes(card.value)}
                            onI2cChange={(e) => handleWhichProducts(card.value)}
                            className="customCheckbox"
                          ></I2cCheckbox>
                        </I2cListItem>
                      </div>
                    ))}
                  </div>
                </I2cCheckboxGroup>
              )}
            />
          </div>
          <div i2c-grid="12 12@md">
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_app_content_for_card_products"
                control={control}
                render={({ field }) => (
                  <I2cTextarea
                    label="Please provide the content for card products."
                    {...field}
                    name="brand_info_web_app_content_for_card_products"
                    resize="none"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      methods.trigger();
                      handleValueChanges();
                    }}
                    placeholder="Enter details"
                    rows={5}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.brand_info_web_app_content_for_card_products &&
                    methods.formState.touchedFields.brand_info_web_app_content_for_card_products
                    ? true
                    : false
                }
                message={errors.brand_info_web_app_content_for_card_products?.message ?? "Invalid input"}
              />
            </div>
          </div>
          <div i2c-grid="12 12@md">
            <div className="custom-label-light mb-1-5">
              For card product images, please select one of the following options.
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_app_responsible_for_card_product_images"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    onI2cChange={(e) => {
                      methods.setValue("brand_info_web_app_responsible_for_card_product_images", e.target.value);
                      if(e.target.value !== "Use client provided images / icons"){
                        methods.setValue("brand_info_web_app_card_product_images_file",[])
                      }
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {card_product_images.map((cpi, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={cpi.label}
                          sublabel=""
                          value=""
                          checked={methods.watch("brand_info_web_app_responsible_for_card_product_images") === cpi.value}
                          type="checkbox"
                        >
                          <I2cRadio
                            slot="prefix"
                            name="credit_programType"
                            value={cpi.value}
                            filled
                            label=""
                            checked={
                              methods.watch("brand_info_web_app_responsible_for_card_product_images") === cpi.value
                            }
                          />
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {
            methods.watch("brand_info_web_app_responsible_for_card_product_images") === "Use client provided images / icons" && (
              <>
                <div i2c-grid="12 12@md">
                  <>
                    <div className="custom-label-light mb-1-5">
                      Upload card product images
                    </div>
                    <Controller
                      name="brand_info_web_app_card_product_images_file"
                      control={control}
                      render={({ field }) => (
                        <I2cFileUpload
                          ref={Manual}
                          max-file-size="0.62722949981689"
                          autoProcessQueue={false}
                          no-mobile-controls
                          setMultiple
                          className="customFileUpload"
                          setAcceptedFiles=".png, .jpg"
                          icon="linear-document-upload"
                          label="Click to upload"
                          caption="or drag and drop"
                          name="brand_info_web_app_card_product_images_file"
                          message="Format: PNG or JPG | Dimensions: min. 1830x1500px"
                          onI2cFileRemoved={(e) => {
                            if (
                              fileJson?.brand_info_web_app_card_product_images_file?.length
                            )
                              methods.setValue(
                                "brand_info_web_app_card_product_images_file",
                                fileJson?.brand_info_web_app_card_product_images_file
                              );
                            else methods.setValue("brand_info_web_app_card_product_images_file", "");
                            methods.trigger();
                            handleValueChanges();
                          }}
                          onI2cAddedFile={(e) => {
                            handleFileUploadImage(
                              Manual.current.getDropZone().files[
                              Manual.current.getDropZone().files.length - 1
                              ], "brand_info_web_app_card_product_images_file"
                            );
                          }}
                        />
                      )}
                    />

                  </>
                </div>
              </>
            )
          }
        </div>
        <div i2c-grid="grid gap-md" className="section-space" ref={el => sectionsRef.current[4] = el}>
          <div i2c-grid="12 8@md" >
            <div className="sub-heading">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  Feature Section V
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
            <div className="custom-label">
              This section can display up to 6 textual content blocks alternating with 6 corresponding images that describe card product features.
            </div>
          </div>
          <div i2c-grid="12 12@md">
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_app_content_for_card_products_features"
                control={control}
                render={({ field }) => (
                  <I2cTextarea
                    label="Please provide the heading and description for all content blocks you have selected."
                    {...field}
                    name="brand_info_web_app_content_for_card_products_features"
                    resize="none"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      methods.trigger();
                      handleValueChanges();
                    }}
                    placeholder="Enter details"
                    rows={5}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.brand_info_web_app_content_for_card_products_features &&
                    methods.formState.touchedFields.brand_info_web_app_content_for_card_products_features
                    ? true
                    : false
                }
                message={errors.brand_info_web_app_content_for_card_products_features?.message ?? "Invalid input"}
              />
            </div>
          </div>
          <div i2c-grid="12 12@md">
            <div className="custom-label-light mb-1-5">
              For content blocks, please select one of the following options.
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_app_responsible_for_card_products_features_images"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    onI2cChange={(e) => {
                      methods.setValue("brand_info_web_app_responsible_for_card_products_features_images", e.target.value);
                      if(e.target.value !== "Use client provided images / icons"){
                        methods.setValue("brand_info_web_app_card_products_features_images_file",[])
                      }
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {content_blocks_images.map((cbi, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={cbi.label}
                          sublabel=""
                          value=""
                          checked={methods.watch("brand_info_web_app_responsible_for_card_products_features_images") === cbi.value}
                          type="checkbox"
                        >
                          <I2cRadio
                            slot="prefix"
                            name="credit_programType"
                            value={cbi.value}
                            filled
                            label=""
                            checked={
                              methods.watch("brand_info_web_app_responsible_for_card_products_features_images") === cbi.value
                            }
                          />
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {
            methods.watch("brand_info_web_app_responsible_for_card_products_features_images") === "Use client provided images / icons" && (
              <div i2c-grid="12 12@md">
                <div className="custom-label-light mb-1-5">
                  Upload card product images
                </div>
                <Controller
                  name="brand_info_web_app_card_products_features_images_file"
                  control={control}
                  render={({ field }) => (
                    <I2cFileUpload
                      ref={Manual}
                      max-file-size="0.62722949981689"
                      autoProcessQueue={false}
                      no-mobile-controls
                      setMultiple
                      className="customFileUpload"
                      setAcceptedFiles=".png, .jpg"
                      icon="linear-document-upload"
                      label="Click to upload"
                      caption="or drag and drop"
                      name="brand_info_web_app_card_products_features_images_file"
                      message="Format: PNG or JPG | Dimensions: min. 1830x1500px"
                      onI2cFileRemoved={(e) => {
                        if (
                          fileJson?.brand_info_web_app_card_products_features_images_file?.length
                        )
                          methods.setValue(
                            "brand_info_web_app_card_products_features_images_file",
                            fileJson?.brand_info_web_app_card_products_features_images_file
                          );
                        else methods.setValue("brand_info_web_app_card_products_features_images_file", "");
                        methods.trigger();
                        handleValueChanges();
                      }}
                      onI2cAddedFile={(e) => {
                        console.log("this is e target", e);
                        console.log("Manual.current.getDropZone().files", Manual.current.getDropZone().files);
                        handleFileUploadImage(
                          Manual.current.getDropZone().files[
                          Manual.current.getDropZone().files.length - 1
                          ], "brand_info_web_app_card_products_features_images_file"
                        );
                      }}
                    />
                  )}
                />
              </div>
            )
          }
        </div>

        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12 8@md">
            <div className="sub-heading">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  Feature Section VI
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
            <div className="custom-label">
              This section can display up to six card product features, with each product feature consisting of a heading, description, and an icon.
            </div>
          </div>
          <div i2c-grid="12 12@md">
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_info_section_vi_add_section_to_landing_page"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Do you want to add this section to the landing page?"
                    {...field}
                    name="brand_info_web_info_section_vi_add_section_to_landing_page"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      if(e.target.value !== "Yes"){
                        methods.setValue("brand_info_web_info_section_vi_icon_textual_content_images_file",[])
                      }
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {add_section_Landing_Options.map((aslo, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("brand_info_web_info_section_vi_add_section_to_landing_page") === aslo
                        }
                        value={aslo}
                      >
                        {aslo}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.brand_info_web_info_section_vi_add_section_to_landing_page &&
                    methods.formState.touchedFields.brand_info_web_info_section_vi_add_section_to_landing_page
                    ? true
                    : false
                }
                message={errors.brand_info_web_info_section_vi_add_section_to_landing_page?.message ?? "Invalid input"}
              />
            </div>
          </div>
          {methods.watch("brand_info_web_info_section_vi_add_section_to_landing_page") === "Yes" && (
            <div i2c-grid="12 12@md">
              <div className="custom-label-light mb-1-5">
                Upload file(s) for icons, textual content, and images of your plastic cards.
              </div>
              <Controller
                name="brand_info_web_info_section_vi_icon_textual_content_images_file" 
                control={control}
                render={({ field }) => (
                  <I2cFileUpload
                    ref={getFileRef("brand_info_web_info_section_vi_icon_textual_content_images_file")}
                    max-file-size="0.62722949981689"
                    autoProcessQueue={false}
                    no-mobile-controls
                    setMultiple
                    className="customFileUpload"
                    setAcceptedFiles=".pdf, .svg, .esp, .ai"
                    icon="linear-document-upload"
                    label="Click to upload"
                    caption="or drag and drop"
                    name="brand_info_web_info_section_vi_icon_textual_content_images_file"
                    message="Format: SVG, AI, PDF or ESP"
                    onI2cFileRemoved={(e) => {
                      if (
                        fileJson?.brand_info_web_info_section_vi_icon_textual_content_images_file?.length
                      )
                        methods.setValue(
                          "brand_info_web_info_section_vi_icon_textual_content_images_file",
                          fileJson?.brand_info_web_info_section_vi_icon_textual_content_images_file,
                        );
                      else methods.setValue("brand_info_web_info_section_vi_icon_textual_content_images_file", "");
                      methods.trigger();
                      handleValueChanges();
                    }}
                    onI2cAddedFile={(e) => {
                      const fileRef = getFileRef("brand_info_web_info_section_vi_icon_textual_content_images_file");
                      handleFileUpload(
                        fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                        "brand_info_web_info_section_vi_icon_textual_content_images_file"
                      );
                    }}
                  />
                )}
              />
            </div>
          )}
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12 8@md">
            <div className="sub-heading">
              <span className="productIconFlex">
                <span slot="label" className="organize-tooltip">
                  Feature Section VII
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
            <div className="custom-label">
              Displays an image of your mobile app and the download links of Google Play and App Store.
            </div>
          </div>
          <div i2c-grid="12 12@md">
            <div className="single-field-wrapper">
              <Controller
                name="brand_info_web_info_add_image_of_mobile_app_section"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Do you want to add this section to the landing page?"
                    {...field}
                    name="brand_info_web_info_add_image_of_mobile_app_section"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      if(e.target.value !== "Yes"){
                        methods.setValue("brand_info_web_info_add_links_for_app",[])
                        methods.setValue("brand_info_web_info_mobile_app_images_file",[])
                      }
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {add_image_of_mobile_Options.map((aiomo, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("brand_info_web_info_add_image_of_mobile_app_section") === aiomo
                        }
                        value={aiomo}
                      >
                        {aiomo}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.brand_info_web_info_add_image_of_mobile_app_section &&
                    methods.formState.touchedFields.brand_info_web_info_add_image_of_mobile_app_section
                    ? true
                    : false
                }
                message={errors.brand_info_web_info_add_image_of_mobile_app_section?.message ?? "Invalid input"}
              />
            </div>
          </div>
          {methods.watch("brand_info_web_info_add_image_of_mobile_app_section") === "Yes" && (
            <>
              <div i2c-grid="12">
                <div className="custom-label-light mb-1-5">
                  Add links for
                </div>
                <Controller
                  name="brand_info_web_info_add_links_for_app"
                  control={control}
                  render={({ field }) => (
                    <I2cCheckboxGroup name="brand_info_web_info_add_links_for_app" ref={checkboxRef}>
                      <div i2c-grid="grid gap-sm">
                        {add_Links_For.map((card, index) => (
                          <div key={index} i2c-grid="6@md">
                            <I2cListItem
                              variant="receipt"
                              label={card.label}
                              sublabel=""
                              value=""
                              type="checkbox"
                              checked={methods
                                .watch("brand_info_web_info_add_links_for_app")
                                .includes(card.value)}
                              onI2cCheckboxClicked={(e) =>
                                handleAddLinks(card.value)
                              }
                            >
                              <I2cCheckbox
                                slot="prefix"
                                value={card.value}
                                label=""
                                ignoreTab
                                filled
                                checked={methods
                                  .watch("brand_info_web_info_add_links_for_app")
                                  .includes(card.value)}
                                onI2cChange={(e) => handleAddLinks(card.value)}
                                className="customCheckbox"
                              ></I2cCheckbox>
                            </I2cListItem>
                          </div>
                        ))}
                      </div>
                    </I2cCheckboxGroup>
                  )}
                />
              </div>
              <div i2c-grid="12">
                <div className="custom-label-light mb-1-5">
                  If you have your own app setup for iOS or Android, please provide app images.
                </div>
                <Controller
                  name="brand_info_web_info_mobile_app_images_file"
                  control={control}
                  render={({ field }) => (
                    <I2cFileUpload
                      ref={Manual}
                      max-file-size="0.62722949981689"
                      autoProcessQueue={false}
                      no-mobile-controls
                      setMultiple
                      className="customFileUpload"
                      setAcceptedFiles=".png,.jpg,.jpeg"
                      icon="linear-document-upload"
                      label="Click to upload"
                      caption="or drag and drop"
                      name="brand_info_web_info_mobile_app_images_file"
                      message="Minimum resolution 750 x 1640 pixels. JPG or PNG Format."
                      onI2cFileRemoved={(e) => {
                        if (
                          fileJson?.brand_info_web_info_mobile_app_images_file?.length
                        )
                          methods.setValue(
                            "brand_info_web_info_mobile_app_images_file",
                            fileJson?.brand_info_web_info_mobile_app_images_file
                          );
                        else methods.setValue("brand_info_web_info_mobile_app_images_file", "");
                        methods.trigger();
                        handleValueChanges();
                      }}
                      onI2cAddedFile={(e) => {
                        handleFileUploadImage(
                          Manual.current.getDropZone().files[
                          Manual.current.getDropZone().files.length - 1
                          ], "brand_info_web_info_mobile_app_images_file"
                        );
                      }}
                    />
                  )}
                />
              </div>
            </>
          )}
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12 8@md">
            <div className="sub-heading">
              <span className="productIconFlex">
                <span>
                  Footer
                </span>
                <AppSelectionIcons
                  appSelectionForProgram={appSelectionForProgram}
                  mobileLink="https://example.com/mobile-app-a"
                  webLink="https://example.com/web-app-a"
                />
              </span>
            </div>
            <div className="custom-label">
              The footer may include issuer statement as well as links to several public pages.
            </div>
          </div>
          <div i2c-grid="12">
            <div className="custom-label-light mb-1-5">
              Please specify the information a cardholder must provide for validation for card activation:
            </div>
            <Controller
              name="brand_info_web_info_footer_public_pages_links"
              control={control}
              render={({ field }) => (
                <I2cCheckboxGroup name="brand_info_web_info_footer_public_pages_links" ref={checkboxRef}>
                  <div i2c-grid="grid gap-sm">
                    {specify_Info.map((card, index) => (
                      <div key={index} i2c-grid="4@md">
                        <I2cListItem
                          variant="receipt"
                          label={card.label}
                          sublabel=""
                          value=""
                          type="checkbox"
                          checked={methods
                            .watch("brand_info_web_info_footer_public_pages_links")
                            .includes(card.value)}
                          onI2cCheckboxClicked={(e) =>
                            handleSpecifyInfo(card.value)
                          }
                        >
                          <I2cCheckbox
                            slot="prefix"
                            value={card.value}
                            label=""
                            ignoreTab
                            filled
                            checked={methods
                              .watch("brand_info_web_info_footer_public_pages_links")
                              .includes(card.value)}
                            onI2cChange={(e) => handleSpecifyInfo(card.value)}
                            className="customCheckbox"
                          ></I2cCheckbox>
                        </I2cListItem>
                      </div>
                    ))}
                  </div>
                </I2cCheckboxGroup>
              )}
            />
          </div>
          <div i2c-grid="12">
            <div className="custom-label-light mb-1-5">
              Upload file that contains the content for the public pages.
            </div>
            <Controller
              name="brand_info_web_info_footer_public_pages_content"
              control={control}
              render={({ field }) => (
                <I2cFileUpload
                ref={getFileRef("brand_info_web_info_footer_public_pages_content")}
                  max-file-size="0.62722949981689"
                  autoProcessQueue={false}
                  no-mobile-controls
                  max-files={1}
                  className="customFileUpload"
                  setAcceptedFiles=".pdf, .svg, .esp, .ai"
                  icon="linear-document-upload"
                  label="Click to upload"
                  caption="or drag and drop"
                  name="brand_info_web_info_footer_public_pages_content"
                  message="Format: SVG, AI, PDF or ESP"
                  onI2cFileRemoved={(e) => {
                    if (
                      fileJson?.brand_info_web_info_footer_public_pages_content?.length
                    )
                      methods.setValue(
                        "brand_info_web_info_footer_public_pages_content",
                        fileJson?.brand_info_web_info_footer_public_pages_content,
                      );
                    else methods.setValue("brand_info_web_info_footer_public_pages_content", "");
                    methods.trigger();
                    handleValueChanges();
                  }}
                  onI2cAddedFile={(e) => {
                    const fileRef = getFileRef("brand_info_web_info_footer_public_pages_content");
                    handleFileUpload(
                      fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                      "brand_info_web_info_footer_public_pages_content"
                    );
                  }}
                />
              )}
            />

          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default WebAppPublicPageSpecifications
